import {useDisclosure} from '@mantine/hooks';
import Head from 'next/head';
import type {GetCompanyInfoResponse} from '../../../../../core/repositories/companiesRepository';
import type {GetCompanyDetailResponse} from '../../../../../core/repositories/companyDetailRepository';
import {BreadcrumbsComponent} from '../../../../../shared/components/BreadcrumbsComponent';
import {NoLoginAlertModal} from '../../../../../shared/components/NoLoginAlertModal';
import {createBreadCrumbsStructuredData} from '../../../../../shared/services/createBreadCrumbsStructuredData';
import {createJsonLdHtml} from '../../../../../shared/services/createJsonLdHtml';
import {CompanyDetailInterests} from '../../CompanyDetailInterests';
import {CompanyHeaderPC} from './CompanyHeaderPC';

type Props = {
  companyInfo: GetCompanyInfoResponse;
  companyDetail: GetCompanyDetailResponse;
  companyName?: string;
  industryName?: string;
  companyLogoURL?: string;
  crumbIndustryName?: string;
  industryIds?: number[];
  industryCategoryId?: number;
  isFollowed: boolean;
  followCount: number;
  onFollow: () => void | Promise<void>;
  entryURL?: string;
  recruitingFairRegistrationURL?: string;
  interestsId?: number;
  isEngineerCompany: boolean;
};

export const CompanyHeaderWrapperPc: React.FC<Props> = ({
  companyInfo,
  companyDetail,
  companyName = '',
  industryName,
  companyLogoURL,
  crumbIndustryName = '',
  industryIds,
  industryCategoryId,
  isFollowed,
  followCount,
  onFollow,
  entryURL,
  recruitingFairRegistrationURL,
  interestsId,
  isEngineerCompany,
}) => {
  const [opened, {close}] = useDisclosure(false);

  const crumbsHref = isEngineerCompany
    ? '/company/industry/engineer'
    : `/company/industry/${industryCategoryId}${industryIds && industryIds?.length > 0 ? `?industryIDs=${industryIds.join(',')}` : ''}`;

  const crumbs = [
    {label: 'Home', href: '/'},
    {label: '企業を探す', href: '/company'},
    {
      label: isEngineerCompany ? 'エンジニア' : crumbIndustryName,
      href: crumbsHref,
    },
    {label: companyName, href: `/company/${companyInfo.id}`},
  ];

  return (
    <>
      <Head>
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={createJsonLdHtml(
            createBreadCrumbsStructuredData(crumbs),
          )}
        />
      </Head>
      <div className="p-8 hidden pc:block">
        <BreadcrumbsComponent crumbs={crumbs} />
      </div>

      <CompanyHeaderPC
        companyLogoURL={companyLogoURL}
        companyName={companyName}
        industryName={industryName ?? ''}
        isFollowed={isFollowed}
        companyId={companyInfo.id}
        companyFollowerCount={companyInfo.followerCount}
        followCount={followCount}
        onFollow={onFollow}
        recruitingFairRegistrationURL={recruitingFairRegistrationURL}
        workAttractiveConditions={
          companyDetail.metaData.workAttractiveConditions
        }
        entryURL={entryURL}
      />
      {interestsId && <CompanyDetailInterests interestsId={interestsId} />}
      <NoLoginAlertModal opened={opened} onClose={close} />
    </>
  );
};
